import React from 'react';
import './Company.css';
import { Route, Routes } from "react-router-dom";
import Header from "../components/Header";
import Survey from "../components/Survey";
import Welcome from "../components/Welcome";
import ConversationalFormBdu from "../bdu/ConversationalForm";
import ConversationalFormRightBank from '../rightBank/ConversationalForm';
import ConversationalFormOrangeRDC from '../orange-rdc/ConversationalForm';
import constants from "../constants";
import { Helmet } from 'react-helmet';
import groupCategoriesByParent from "../orange-rdc/formatter";
import createQuestionsPerFlow from "../orange-rdc/questionBuilder";
import createcategoriesPerFlow from "../orange-rdc/formCategoryBuilder";

const Company = (props) => {
  const [company, setCompany] = React.useState();
  const [formData, setFormData] = React.useState(undefined);
  const [cfTags, setCFTags] = React.useState([]);
  const [questionsPerFlow, setQuestionsPerFlow] = React.useState([]);
  const [loading, setLoading] = React.useState(true);
  const [error, setError] = React.useState(undefined);
  const [categories, setCategories] = React.useState([]);
  const [customerFields, setCustomerFields] = React.useState([]);

  const loadOrangeRDC = () => {
    const companyData = {
      apikey: "HP6R2KC9IT3M",
      apps: [
        {
          app_code: "rightcare",
          app_full_description: {
            en: "RightDesk is a cloud-based customer service software solution.",
            fr: "RightDesk est une solution logiciel de service client basée sur le cloud.",
          },
          app_name: "RightDesk",
          app_short_description: {
            en: "Customer Service Software",
            fr: "Logiciel de service client",
          },
          link: "",
          purchased_at: "Mon Nov 08 13:50:37 UTC 2021",
        },
      ],
      background_image_url: "",
      companyAdress: {
        city: "",
        email: "contact@orange.cd",
        full_adress: "",
        phone: "",
      },
      company_owner_firstname: "",
      company_owner_lastname: "",
      country: {
        country_id: "108",
        countrycode: "CD",
        countryname: "DR Congo",
      },
      customer_id: "",
      language: "fr",
      logo: "",
      logo_url: "",
      name: "Orange RDC",
      publickey: "HP6R2KC9IT3M",
      resselers: [],
      status: 1,
      subdomain: "orange-rdc",
      timezone: "",
      updated_date: "",
      website: "",
      website_url: "#",
      welcome_message: "Bienvenue chez Orange RDC",
    };

    const resultFormData = {
      background_color: "#FF7900",
      support_link: constants.prod.rightDeskUrlV2,
      survey_link: "",
      text_color: "#ffffff",
    };

    setCompany(companyData);
    setFormData(resultFormData);

    const myHeaders = new Headers();
    myHeaders.append("Content-Type", "application/json");
    const requestOptions = { method: 'GET', headers: myHeaders, redirect: 'follow' };

    fetch(constants.prod.rightDeskUrlV2 + "/api/v1/webform/general?subdomaine=orange-rdc", requestOptions)
      .then(response => response.json())
      .then(result => {
        const subjects = result.data.auto_priorization_subjects;
        const customerFieldsData = result.data.lang_fr?.customer_information?.items || [];
        setCategories(createcategoriesPerFlow(subjects));
        setCFTags(groupCategoriesByParent(subjects));
        setQuestionsPerFlow(createQuestionsPerFlow(subjects, customerFieldsData));
        setCustomerFields(customerFieldsData);
        setLoading(false);
      })
      .catch(err => setError(err));
  };

  const loadDefaultTenant = () => {
    fetch(constants.prod.accountClientUrl + '/api/v2/checkcompany?tokenkey=AIzaSyDY0kkJiTPVd2U7aTOAwhc9ySH6oHx0IYM&alias=' + props.company)
      .then(r => r.json())
      .then(data => {
        if (data.status === 200) {
          loadCompanyFormData(data.data);
        } else {
          setError("No Company Found");
        }
      })
      .catch(err => setError(err));
  };

  const loadCompanyFormData = (data) => {
    const myHeaders = new Headers();
    myHeaders.append("Content-Type", "application/json");
    const raw = JSON.stringify({ "alias": data.subdomain });
    const requestOptions = { method: 'POST', headers: myHeaders, body: raw, redirect: 'follow' };

    fetch(constants.prod.adminApiUrl + "/api/notebook/read", requestOptions)
      .then(response => response.json())
      .then(result => {
        setFormData(result.data);
        setCompany(data);
        loadCompanyCategories(data);
      })
      .catch(err => setError(err));
  };

  const loadCompanyCategories = (data) => {
    const myHeaders = new Headers();
    myHeaders.append("Content-Type", "application/json");
    const requestOptions = { method: 'GET', headers: myHeaders, redirect: 'follow' };

    fetch(constants.prod.rightDeskUrl + "/api/v1/webform/general?subdomaine=" + data.subdomain, requestOptions)
      .then(response => response.json())
      .then(result => {
        setCategories(result.data.auto_priorization_subjects);
        setLoading(false);
      })
      .catch(err => setError(err));
  };

  React.useEffect(() => {
    setLoading(true);
    setError(undefined);

    if (props.company === 'orange-rdc') {
      loadOrangeRDC();
    } else {
      loadDefaultTenant();
    }
  }, [props.company]);

  const renderBot = () => {
    if (props.company === 'orange-rdc') {
      return (
        <ConversationalFormOrangeRDC
          cfTags={cfTags}
          questionsPerFlow={questionsPerFlow}
          company={props.company}
          companyData={company}
          formData={formData}
          categories={categories}
          customerFields={customerFields}
        />
      );
    }
    if (company?.subdomain === "demo") {
      return (
        <ConversationalFormRightBank
          company={props.company}
          companyData={company}
          formData={formData}
          categories={categories}
        />
      );
    }
    return (
      <ConversationalFormBdu
        company={props.company}
        companyData={company}
        formData={formData}
        categories={categories}
      />
    );
  };

  return (
    <div className="Company">
      <Helmet>
        <title>CX Webform</title>
        <meta
          name="description"
          content={company?.language === "fr"
            ? "Logiciel de gestion d’expérience client propulsé par RightCom"
            : "Customer Experience Management software powered by RightCom"}
        />
      </Helmet>
      {loading ? (
        <div>
          <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', height: '99vh' }}>
            {!error && <div className={`loader${props.company === 'orange-rdc' ? ' loader--orange-rdc' : ''}`}></div>}
            {error && <div>{error}</div>}
          </div>
        </div>
      ) : (
        <Routes>
          <Route
            exact
            path={'/'}
            element={<Welcome company={props.company} companyData={company} formData={formData}/>}
          />
          <Route
            exact
            path={'/bot'}
            element={
              <>
                <Header company={props.company} companyData={company} formData={formData}/>
                {renderBot()}
              </>
            }
          />
          <Route
            exact
            path={'/bot/not-header'}
            element={renderBot()}
          />
          <Route
            exact
            path={'/survey'}
            element={
              <>
                <Header company={props.company} companyData={company} formData={formData}/>
                <Survey company={props.company} companyData={company} formData={formData}/>
              </>
            }
          />
        </Routes>
      )}
    </div>
  );
};

export default Company;
